import React, { Component } from 'react';

import RWT from '../../../../../utils/react-twitter-text';

import { withRouter } from 'react-router-dom';

import 'custom-event-polyfill';

class ShowPostText extends Component {
	render() {
		const post = this.props.post;

		return (
			<RWT
				post={post}
				tweetText={post.m.m}
				twitterTextOptions={{
					hashtagUrlBase: '/tags/',
					cashtagUrlBase: null,
					usernameUrlBase: '/profile/',
					listUrlBase: null,
				}}
				redirectCallback={(a) => {
					const url = document.location.href.split('/').slice(0, 3).join('/');

					a = a.replace(url, '');

					const ce = new CustomEvent('react_social_click_on_post_link', {
						view: window,
						bubbles: true,
						detail: {
							pid: post.h,
							post,
							url: a,
						},
					});

					document.dispatchEvent(ce);

					if (a.match(/^http/)) {
						window.open(a);
						return;
					} else {
						this.props.history.push(a);
					}
				}}
			/>
		);
	}
}
export default withRouter(ShowPostText);
